import React from "react"
import { SlMagnifier } from "react-icons/sl"

const SearchBar = ({ searchTerm, setSearchTerm, placeholder = "Search...", style = "" }) => {
  return (
    <div className={`relative ${style}`}>
      <SlMagnifier className="absolute left-7 top-1/2 transform -translate-y-1/2 text-gray-500 h-5 w-5" />
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
      />
    </div>
  )
}

export default SearchBar
